import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable, combineLatest, map, switchMap, take } from 'rxjs';
import { CountryPipe } from './country.pipe';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class CountryService {
  constructor(private translocoService: TranslocoService) {}

  getSortedCountries(countries: string[]): Observable<string[]> {
    const countryPipe = new CountryPipe(this.translocoService);

    return this.translocoService.langChanges$.pipe(
      switchMap(() => combineLatest(countries.map(c => countryPipe.transform(c))).pipe(take(1))),
      map(translations =>
        countries.slice().sort((c1, c2) => {
          const i1 = countries.indexOf(c1);
          const i2 = countries.indexOf(c2);
          return translations[i1].localeCompare(translations[i2]);
        })
      )
    );
  }
}
